export enum mobileVerificationActions {
  PUSH = 'mobileVerification/push',
  REPLACE = 'mobileVerification/replace',
  SET_SUGGESTED_MOBILE = 'mobileVerification/setSuggestedMobile',
  DISABLE_FLOW = 'mobileVerification/disableFlow',
  SET_SUGGESTED_MOBILE_LIST = 'mobileVerification/setSuggestedMobileList'
}

